module.exports = __webpack_public_path__ + "static/media/2025Benefithilight_HMO.5e7363ca.pdf";